import React from 'react';
import {Field } from 'formik';
import "../../../css/report.css"

function InvestigationInputItem(props) 
    {
    let investigationId=`${props.typeOfInvestigation}.${props.investigationName}`

    return (
         <p className={props.displayClass}>  
        <label htmlFor ={investigationId}>{props.investigationName}</label>
        <Field type="checkbox" id={investigationId} name={investigationId} checked={props.initialValues[investigationId]} />
        </p>  
    );
    }

export default InvestigationInputItem;